import { Component, Inject } from '@angular/core';
import { GoDialogRef } from '@go-modules/services/go-dialog-ref/go-dialog-ref';
import { GO_MODAL_DATA } from '@go-modules/services/go-modal/go-modal.tokens';
import { Activity } from '@go-modules/interfaces/activity';
import { UADetect as UADetectClass, uaDetectToken } from 'go-modules/detect/ua-detect.service';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

@Component({
	selector: 'start-test-dialog',
	templateUrl: './start-test-dialog.component.html',
	styleUrls: ['./start-test-dialog.component.scss'],
	standalone: false
})
export class StartTestDialogComponent {
	public dialogTitleId = `start-test-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	constructor (
		public dialogRef: GoDialogRef,
		@Inject(GO_MODAL_DATA) public data: {
			currentActivity: Activity;
		},
		@Inject(uaDetectToken) private UADetect: UADetectClass
	) {}

	public cancel () {
		this.dialogRef.close(false);
	}

	public confirm () {
		this.dialogRef.close(true);
	}

	public showScreenCaptureWarning (): boolean {
		return this.UADetect.browserDetector.isFirefox() || this.UADetect.browserDetector.isSafari();
	}
}
